import { useTranslation } from 'react-i18next';
import Paper from '~/components/Paper.tsx';
import ButtonBase from '~/components/ButtonBase.tsx';
import Typography from '~/components/Typography.tsx';
import { useNavigate } from 'react-router-dom';

export default function HeaderMenu() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const handleMoveToMyLikes = () => {
    navigate('/shop/likes?tab=product');
  };
  const handleMoveToMyCoupons = () => {
    navigate('/shop/coupons?tab=in-possession');
  };
  const handleMoveToMyReview = () => {
    navigate('/shop/my-review');
  };

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        boxShadow: 'none',
        backgroundColor: '#f5f7fa',
      }}
    >
      <ButtonBase
        sx={(theme) => ({
          display: 'block',
          width: '100%',
          flex: 1,
          paddingY: '12px',
          '&::after': {
            right: 0,
            content: '""',
            position: 'absolute',
            height: 'calc(100% - 24px)',
            width: '1px',
            backgroundColor: theme.palette.divider,
          },
          boxSizing: null,
        })}
        onClick={handleMoveToMyLikes}
      >
        <Typography
          component={'span'}
          variant={'BaseS_B'}
          color={'text.secondary'}
          fontWeight={'500'}
        >
          {i18n.t('common-like')}
        </Typography>
      </ButtonBase>
      <ButtonBase
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          flex: 1,
          paddingY: '12px',
          '&::after': {
            right: 0,
            content: '""',
            position: 'absolute',
            height: 'calc(100% - 24px)',
            width: '1px',
            backgroundColor: theme.palette.divider,
          },
          boxSizing: null,
        })}
        onClick={handleMoveToMyCoupons}
      >
        <Typography component={'span'} variant={'BaseS_B'} color={'text.secondary'}>
          {i18n.t('shop-my-coupon')}
        </Typography>
      </ButtonBase>
      <ButtonBase
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          flex: 1,
          paddingY: '12px',
        }}
        onClick={handleMoveToMyReview}
      >
        <Typography component={'span'} variant={'BaseS_B'} color={'text.secondary'}>
          {i18n.t('common-review')}
        </Typography>
      </ButtonBase>
    </Paper>
  );
}
